<template>
  <div class="burger">
    <div
        class="burger-container"
        @click="changeNavStatus"
    >
      <div class="burger-line">

      </div>
      <div class="burger-line">

      </div>
      <div class="burger-line">

      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: "NavBurger",
  methods: {
    ...mapMutations([
      "changeNavStatus"
    ]),
  }
}
</script>

<style lang="scss" scoped>
.burger {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 20px;
  right: 20px;
  height: 44px;
  &-container {
    width: 30px;
    height: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  &-line {
    height: 5px;
    width: 100%;
    border-radius: 2px;
    background-color: #26ade4;
    transition: .5s ease;
  }
}

@media only screen and (min-width : 768px) {
  .burger {
    display: none;
  }
}

</style>